import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from '../crud.service';
import { Notification } from '../../models/notification';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService extends CrudService<Notification> {
  protected basePath = 'notification'; // Specific for NotificationService
  public instanceType = 'notification'; // Used in base service for constructing URLs

  constructor(http: HttpClient) {
    super(http);
  }

  override getItemsAsPromise() {
    return lastValueFrom(
      this.http.get<{ [key: string]: Notification }>(`${this.getBaseUrl()}`)
    );
  }
}
